export default __webpack_public_path__ + "static/media/0x9aceb6f749396d1930abc9e263efc449e5e82c13.b3f6bb3b.webp";